<template lang="pug">
.sidebar(data-color='purple')
  .logo
    a.simple-text(href='http://www.eved.com')
      img(src='~images/../logo.svg', height='35')
  .sidebar-wrapper
    navbar-search(v-if='open')
    navbar-right(v-if='open', :mobile='true')
    ul.nav(v-for='(page, key) in pages')
      item(:title='page.alias || page', icon='dashboard', :href='key')
  .sidebar-background
</template>

<script>

import siteMap from '@/core/site-map'
import Item from './item'
import NavbarSearch from '@/components/Navigation/navbar-search'
import NavbarRight from '@/components/Navigation/navbar-right'

export default {
  props: {
    open: Boolean
  },
  components: {
    Item,
    NavbarSearch,
    NavbarRight
  },
  computed: {
    pages: function () {
      return siteMap.data().sitemap
    }
  }
}
</script>

<style lang='scss'>
.sidebar-background {
  background-color: #51226C;
}
</style>




// WEBPACK FOOTER //
// index.vue?449a598f